(function () {
  'use strict';

  function activate(root, tab, shouldFocus) {
    if (!root || !tab) return;
    var targetId = tab.getAttribute('data-review-target');
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-review-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-review-panel]'));

    tabs.forEach(function (item) {
      var active = item === tab;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-selected', active ? 'true' : 'false');
      item.setAttribute('tabindex', active ? '0' : '-1');
    });

    panels.forEach(function (panel) {
      var active = panel.id === targetId;
      panel.classList.toggle('is-active', active);
      panel.hidden = !active;
    });

    if (shouldFocus) tab.focus();

    if (window.ecTrack) {
      window.ecTrack('ec_review_theme_selected', {
        module_id: root.getAttribute('data-module-id') || 'EC-MOD-0005',
        review_theme: tab.getAttribute('data-review-key') || 'review'
      });
    }
  }

  function init(root) {
    if (!root || root.getAttribute('data-ec-ready') === 'true') return;
    root.setAttribute('data-ec-ready', 'true');
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-review-tab]'));

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () {
        activate(root, tab, false);
      });

      tab.addEventListener('keydown', function (event) {
        var nextIndex = index;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = tabs.length - 1;
        if (nextIndex !== index) {
          event.preventDefault();
          activate(root, tabs[nextIndex], true);
        }
      });
    });
  }

  function initAll(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-ec-review-evidence]'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:block:select', function (event) {
    var root = event.target && event.target.closest ? event.target.closest('[data-ec-review-evidence]') : null;
    if (!root || !event.detail || !event.detail.blockId) return;
    var panel = root.querySelector('[data-block-id="' + event.detail.blockId + '"]');
    if (!panel) return;
    var tab = root.querySelector('[data-review-target="' + panel.id + '"]');
    activate(root, tab, false);
  });
})();
